export class ResponseNewFaseAnual{
    payload:NewFaseAnual;

    constructor(){
        this.payload = new NewFaseAnual();
    }
}

export class NewFaseAnual{    
    idPlanMejora:number;
    idJardinPeriodo:number;
    estado:number;
    periodos:AniosPMEModel[];
    esNuevo:boolean;
    
     constructor(){
        this.idPlanMejora = -1;
        this.idJardinPeriodo = -1;
        this.estado = -1;
        this.periodos = new Array<AniosPMEModel>();
        this.esNuevo = false;
    }
}

export class AniosPMEModel{   
    dimensiones:DimensionesAnualPMEModel[];
    estado:number;
    anio:number;
    orden:number;
    idPeriodo:number;
    estadoAnio:number;
    constructor(){
        this.estado = -1;
        this.orden = -1;
        this.idPeriodo = -1;
        this.estadoAnio = -1;
        this.dimensiones = new Array<DimensionesAnualPMEModel>();
    }
}

export class DimensionesAnualPMEModel{    

    dimension:string;
    idDimension:number; 
    orden:number;
    subdimensiones:SubdimensionAnualPMEModel[];
    constructor(){
        this.dimension = "";
        this.idDimension = -1;
        this.orden = -1;
        this.subdimensiones = new Array<SubdimensionAnualPMEModel>();
    }
}

export class SubdimensionAnualPMEModel{    

    idSubDimensionPME:number;
    orden:number;
    nombreCorto:string;
    subDimension:string;
    objetivo:string;
    meta:string;
    faseAnual:FaseAnualPME;
    constructor(){
        this.idSubDimensionPME = -1;
        this.orden = -1;
        this.nombreCorto = "";
        this.subDimension = "";
        this.objetivo = "";
        this.meta = "";
    }

    
}



export class FaseAnualPME{    

    idFaseAnualPME:number;
    idFaseAnualAnioPME:number;
    idObjetivoPME:number;
    estrategia1:string;
    estrategia2:string;
    indicador1e1:string;
    indicador2e1:string;
    indicador1e2:string;
    indicador2e2:string;
    accion1e1:string;
    accion2e1:string;
    accion1e2:string;
    accion2e2:string;
    responsable1e1:string;
    responsable2e1:string;
    responsable1e2:string;
    responsable2e2:string;
    recurso1e1:string;
    recurso2e1:string;
    recurso1e2:string;
    recurso2e2:string;
    fechaDesde1e1:Date;
    fechaDesde2e1:Date;
    fechaDesde1e2:Date;
    fechaDesde2e2:Date;
    fechaHasta1e1:Date;
    fechaHasta2e1:Date;
    fechaHasta1e2:Date;
    fechaHasta2e2:Date;
    disabled:boolean;
    constructor(){
        this.idFaseAnualPME = -1;
        this.idFaseAnualAnioPME = -1;
        this.idObjetivoPME = -1;
        this.estrategia1 = "";
        this.estrategia2 = "";
        this.indicador1e1 = "";
        this.indicador2e1 = "";
        this.indicador1e2 = "";
        this.indicador2e2 = "";
        this.accion1e1 = "";
        this.accion2e1 = "";
        this.accion1e2 = "";
        this.accion2e2 = "";
        this.responsable1e1 = "";
        this.responsable2e1 = "";
        this.responsable1e2 = "";
        this.responsable2e2 = "";
        this.recurso1e1 = "";
        this.recurso2e1 = "";
        this.recurso1e2 = "";
        this.recurso2e2 = "";
        this.fechaDesde1e1 = null;
        this.fechaDesde2e1 = null;
        this.fechaDesde1e2 = null;
        this.fechaDesde2e2 = null;
        this.fechaHasta1e1 = null;
        this.fechaHasta2e1 = null;
        this.fechaHasta1e2 = null;
        this.fechaHasta2e2 = null;
        this.disabled =true;
    }

}
